import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import React, { CSSProperties, FunctionComponent, ReactNode } from 'react';
import { useTheme } from 'styled-components';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { Text } from '../typography';
import { CloseIcon, Container } from './Tag.style';

interface Props {
  containerStyle?: CSSProperties;
  onCloseClick: () => void;
  closeTestID?: string;
  children: ReactNode;
}

const Tag: FunctionComponent<Props> = (props) => {
  const theme = useTheme();

  return (
    <Container style={props.containerStyle}>
      <Text color={theme.white} fontWeight="600" fontSize={14} mb={2}>
        {props.children}
      </Text>

      {props.onCloseClick && (
        <CloseIcon data-testid={props.closeTestID} onClick={props.onCloseClick} type="button">
          <FontAwesomeIcon icon={faTimes} color={theme.white} style={{ fontSize: 14 }} />
        </CloseIcon>
      )}
    </Container>
  );
};

export default Tag;
